export enum OptionMenuItemCallback {
  None = 'NONE',
  Delete = 'DELETE',
  Edit = 'EDIT',
  Replace = 'REPLACE',
  Duplicate = 'DUPLICATE',
  Preview = 'PREVIEW',
  Settings = 'SETTINGS',
  Download = 'DOWNLOAD',
  Move = 'MOVE',
  MoveToTop = 'MOVE TO TOP',
  MoveUp = 'MOVE UP',
  MoveDown = 'MOVE DOWN',
  MoveToBottom = 'MOVE TO BOTTOM',
  CreateDocument = 'CREATE DOCUMENT',
  GoogleDocs = 'GOOGLE DOCS',
  ConditionalLogic = 'CONDITIONAL LOGIC',
  CustomData = 'CUSTOM DATA',
  SectionColors = 'SECTION COLORS',
  SaveAsTemplate = 'SAVE AS TEMPLATE',
}

export enum OptionMenuDocumentViewCallback {
  None = 'NONE',
  Name = 'NAME',
  Sent = 'SENT',
  Reschedule = 'RESCHEDULE',
  Preview = 'PREVIEW',
  UpdateExpiration = 'UPDATE EXPIRATION',
  UpdateDealValue = 'UPDATE DEAL VALUE',
  SendVideoReminder = 'SEND VIDEO REMINDER',
  SendReminderEmail = 'SEND REMINDER EMAIL',
  SendSMS = 'SEND SMS',
  UpcomingActivities = 'UPCOMING ACTIVITIES',
  AddNewRecipient = 'ADD NEW RECIPIENT',
  Download = 'DOWNLOAD',
  UploadSignedDocument = 'UPLOAD SIGNED DOCUMENT',
  MarkAsLost = 'MARK AS LOST',
  DeleteDocument = 'DELETE DOCUMENT',
  CreateNewVersion = 'CREATE NEW VERSION',
  ChangeDocumentOwner = 'CHANGE DOCUMENT OWNER',
  ExportFieldData = 'EXPORT FIELD DATA',
  FlagAsWon = 'FLAG AS WON',
  RecallDeal = 'RECALL DEAL',
  CancelSending = 'CANCEL SENDING',
  OpenExternalEditor = 'OPEN EXTERNAL EDITOR',
  PreviousVersion = 'GO TO PREVIOUS VERSION',
  ShareLink = 'SHARE LINK',
  ConvertToSignable = 'CONVERT TO SIGNABLE',
  CustomData = 'CUSTOM DATA',
  OpenCRMLink = 'OPEN CRM LINK',
  SaveAsTemplate = 'SAVE AS TEMPLATE',
}
